export default "__VITE_ASSET__nHliyDgH__"